/**
 * Salas Module Routes (E13.2.1, E13.2.2).
 *
 * Rotas do módulo Agendamento de Salas. RBAC: `/salas`, `/salas/disponibilidade` (as reservas de todas as
 * salas, 5a) e `/salas/:roomId/calendar` exigem `rooms:read`; `/salas/gerir` (gestão de salas, 15/10/2026)
 * exige `rooms:update`.
 * Story E13.2.3 adicionará booking modal (sem rota dedicada — overlay
 * sobre a calendar view).
 *
 * `/salas/gerir` e `/salas/disponibilidade` não têm item no menu (o ⚙ "Gerir salas" mora em `/salas`; a
 * disponibilidade se abre pelos links das páginas de salas e do calendário) e não precisam de linha
 * nova no `PATH_TO_MODULE_ID` do Sidebar: aquele mapa só pinta item de MENU de nível 0, pelo
 * primeiro segmento do caminho, e o item "Salas" (`/salas`) já os cobre (o item não fica aceso nelas:
 * o menu compara o caminho inteiro, como em `/salas/:roomId/calendar`).
 */

import { lazy } from "react";
import { ModuleRoutes } from "../types";

const SalasListPage = lazy(() => import("@/pages/salas/SalasListPage"));
const RoomCalendarPage = lazy(() => import("@/pages/salas/RoomCalendarPage"));
const GerirSalasPage = lazy(() => import("@/pages/salas/GerirSalasPage"));
const DisponibilidadePage = lazy(() => import("@/pages/salas/disponibilidade/DisponibilidadePage"));

export const salasRoutes: ModuleRoutes = {
  moduleId: "salas",
  basePath: "/salas",
  routes: [
    {
      path: "/salas",
      element: <SalasListPage />,
      permission: { resource: "rooms", action: "read" },
    },
    {
      path: "/salas/disponibilidade",
      element: <DisponibilidadePage />,
      permission: { resource: "rooms", action: "read" },
    },
    {
      path: "/salas/gerir",
      element: <GerirSalasPage />,
      permission: { resource: "rooms", action: "update" },
    },
    {
      path: "/salas/:roomId/calendar",
      element: <RoomCalendarPage />,
      permission: { resource: "rooms", action: "read" },
    },
  ],
};
